import { ArrowRightIcon, CheckCircleIcon, CrownSimpleIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";

import { useDialog } from "@/client/stores/dialog";

type OfferCardProps = {
  className?: string;
};

const benefits = ["Plus de CV", "Score ATS", "Assistant IA"];

export const OfferCard = ({ className }: OfferCardProps) => {
  const { open: openOffers } = useDialog("forfait");

  const handleOpenOffers = () => {
    openOffers("create", {
      id: "forfait",
    });
  };

  return (
    <article
      className={cn(
        "relative flex min-h-[370px] flex-col overflow-hidden",
        "rounded-2xl border border-indigo-400",
        "bg-gradient-to-br from-indigo-700 via-violet-700 to-indigo-900",
        "p-5 text-white",
        "shadow-[0_15px_35px_rgba(67,56,202,0.22)]",
        className,
      )}
    >
      <div
        aria-hidden
        className="absolute -right-16 -top-16 size-44 rounded-full bg-cyan-400/25 blur-3xl"
      />

      <div
        aria-hidden
        className="absolute -bottom-20 -left-16 size-48 rounded-full bg-emerald-400/20 blur-3xl"
      />

      <div className="relative flex flex-1 flex-col items-center justify-center text-center">
        <span className="grid size-14 place-items-center rounded-2xl bg-emerald-300 text-indigo-800 shadow-lg">
          <CrownSimpleIcon aria-hidden size={30} weight="fill" />
        </span>

        <p className="mt-4 rounded-full bg-emerald-300 px-4 py-1.5 text-[11px] font-bold uppercase tracking-wide text-indigo-900">
          Passez au niveau supérieur
        </p>

        <h2 className="mt-5 max-w-xs text-2xl font-bold leading-tight">
          Accélérez chaque candidature
        </h2>

        <p className="mt-3 max-w-xs text-[13px] leading-5 text-indigo-100">
          Plus de CV, un score ATS et l’assistance IA pour multiplier vos opportunités.
        </p>

        <ul className="mt-5 flex flex-wrap justify-center gap-2">
          {benefits.map((benefit) => (
            <li
              key={benefit}
              className="flex items-center gap-1.5 rounded-full bg-white/10 px-2.5 py-1.5 text-[10px] font-medium"
            >
              <CheckCircleIcon aria-hidden size={14} weight="fill" className="text-emerald-300" />

              {benefit}
            </li>
          ))}
        </ul>
      </div>

      <button
        type="button"
        onClick={handleOpenOffers}
        className={cn(
          "relative mt-5 flex min-h-12 items-center justify-center gap-2",
          "rounded-xl bg-white px-4 text-[13px]",
          "font-bold text-indigo-700",
          "transition-all duration-200",
          "hover:-translate-y-0.5 hover:bg-indigo-50",
          "focus-visible:outline-none focus-visible:ring-2",
          "focus-visible:ring-white focus-visible:ring-offset-2",
          "focus-visible:ring-offset-indigo-700",
        )}
      >
        Découvrir les offres
        <ArrowRightIcon aria-hidden size={17} weight="bold" />
      </button>
    </article>
  );
};
